export default {"src":"/_next/static/media/seance.b93c58fe.svg","height":29,"width":428};